import { Stack } from "PFComponents/containers";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useTranslation } from "react-i18next";

type InterestQuestionsSelectorProps = {
  disabled?: boolean;
  questions: string[];
  error?: string;
  onQuestionsChange: (questions: string[]) => void;
};

export const InterestQuestionsSelector = ({
  disabled = false,
  questions,
  error,
  onQuestionsChange
}: InterestQuestionsSelectorProps) => {
  const { t } = useTranslation("activities", {
    keyPrefix: "form.sections.showInterestQuestions"
  });

  const handleQuestionChange = (index: number, value: string) => {
    const newQuestions = [...questions];
    newQuestions[index] = value;
    onQuestionsChange(newQuestions);
  };

  return (
    <Stack gap="spacingMd">
      {questions.map((value, index) => (
        <InputFieldSet
          label={t("questionLabel", { id: index + 1 })}
          disabled={disabled}
          error={index === 0 ? error : undefined}
          key={index}
          value={value}
          onChange={(newValue: string) => handleQuestionChange(index, newValue)}
          inputType="textarea"
          maxLength={120}
          minVisibleMaxLengthFactor={1}
        />
      ))}
    </Stack>
  );
};
